import React from 'react';

import PropTypes from 'prop-types';

import { CheckboxRow } from 'components/CheckboxRow/CheckboxRow';

import { BRANCH_TYPE } from 'global/constants';

import { isInstallerRegisteringForBranch } from 'utils/InstallerUtils';

import './NEFIAgreementSection.sass';

export const NEFIAgreementSection = ({
  energyAgreementLink,
  gasAgreementLink,
  branchSelectionValues,
  formik,
}) => (
  <div className="nefi-agreement-section__wrapper">
    {isInstallerRegisteringForBranch(BRANCH_TYPE.ENERGY, branchSelectionValues) && (
      <CheckboxRow
        name="energyAgreement"
        title="Erklärung zur Eintragung in das Elektro-Installateur-Verzeichnis"
        label="Ich verpflichte mich folgendes verbindlich anzuerkennen*:"
        documentLink={energyAgreementLink}
        value={formik.values.energyAgreement}
        onChange={formik.handleChange}
        error={Boolean(formik.errors.energyAgreement)}
      />
    )}
    {isInstallerRegisteringForBranch(BRANCH_TYPE.GAS, branchSelectionValues) && (
      <CheckboxRow
        name="gasAgreement"
        title="Erklärung zur Eintragung in das Gas-Installateur-Verzeichnis"
        label="Ich verpflichte mich folgendes verbindlich anzuerkennen*:"
        documentLink={gasAgreementLink}
        value={formik.values.gasAgreement}
        onChange={formik.handleChange}
        error={Boolean(formik.errors.gasAgreement)}
      />
    )}
  </div>
);

NEFIAgreementSection.propTypes = {
  energyAgreementLink: PropTypes.string,
  gasAgreementLink: PropTypes.string,
  branchSelectionValues: PropTypes.object,
  formik: PropTypes.object,
};

NEFIAgreementSection.defaultProps = {
  energyAgreementLink: '',
  gasAgreementLink: '',
  branchSelectionValues: {},
  formik: {},
};
